import ToggleButton from "./toggle-button";
import { ButtonRow } from "./toolbar-design-system";

export function LineDash({ values, onChange }: { values: Record<number, boolean>; onChange: (value: number) => void }) {
  return (
    <ButtonRow>
      {/* solid line */}
      <ToggleButton isOn={values[0]} onClick={() => onChange(0)}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="0%" y1="50%" x2="100%" y2="50%" stroke="white" strokeLinecap="round" strokeWidth={1} />
        </svg>
      </ToggleButton>

      <ToggleButton isOn={values[1]} onClick={() => onChange(1)}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line
            x1="0%"
            y1="50%"
            x2="100%"
            y2="50%"
            stroke="white"
            strokeLinecap="round"
            strokeWidth={1}
            strokeDasharray="3 2"
          />
        </svg>
      </ToggleButton>

      <ToggleButton isOn={values[2]} onClick={() => onChange(2)}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line
            x1="0%"
            y1="50%"
            x2="100%"
            y2="50%"
            stroke="white"
            strokeLinecap="round"
            strokeWidth={1}
            strokeDasharray="1 2"
          />
        </svg>
      </ToggleButton>
    </ButtonRow>
  );
}
